import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
import util from '@/base/js/util'
import {constRouters, asyncRouters, errorPage, ROUTES_MAP ,index} from "../router/router"
import {_getNewTotal,_clearNewTotal} from '@/api/notify';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    addRoutes: [],
    routes: constRouters,
    userInfo: util.getSession('userInfo')||null,
    message_total:""
  },
  getters:{
    // group_id: state=>{
    //   return state.userInfo.group_id
    // }
  },
  mutations: {
    //事件存储数据到state（状态）
    updateUserInfo(state, userInfo) {
      state.userInfo = {...userInfo};
      util.setSession('userInfo',userInfo);
    },
    setInfo(state,info){
      localStorage.setItem('myInfo', JSON.stringify(info)); //将传递的数据先保存到localStorage中
      state.message_total = info;// 之后才是修改state中的状态
    },
    SET_ROUTES: (state, addRoutes) => {
      // console.log(state.routes);
      // console.log(addRoutes);
      state.addRoutes = addRoutes
      state.routes = state.routes.concat([...addRoutes])
      // console.log(state.routes);
    },
    INIT_STATE: (state, newState)=>{
      state = Object.assign(state,newState)
    },
    //获取消息的数量
    initMessageTot:(state,num)=>{
      state.message_total=num;
    },
    //清除消息的数量
    clearMessageTot:(state,num)=>{
      state.message_total=num;
    }
  },
  actions: {
    GenerateRoutes({commit,state}) {
      return new Promise((resolve, reject) => {
        let origin_routes_list = [],
          addRoutes = []
        //拿到后端返回的权限列表并转换成前端对应的路由表
        ROUTES_MAP.forEach(r_key=>{
          state.userInfo.columns.forEach(c_key => {
            if(c_key.id==r_key.id){
              origin_routes_list.push(
                asyncRouters[r_key.name]
              )
            }
          })
        })
        //添加主路由重定向路径
        let customIndex = index
        addRoutes.push(customIndex);
        //添加权限判断
        if(origin_routes_list.length>0){
          addRoutes.push(...origin_routes_list,errorPage);          
        }else{
          addRoutes.push(errorPage);
        }
        commit('SET_ROUTES',addRoutes)
        resolve()
      })
    },
    removeRoutes({commit}){
      const newState = {
        addRoutes: [],
        routes: constRouters,
        userInfo: util.getSession('userInfo') || {
          uid: 0,
          token: Cookies.get('token')
        },
      }
      commit('INIT_STATE',newState)
    },
    //获取数量的接口
    getMessageTotAsy(context){
      _getNewTotal().then(res=>{
        if(res.resultCode==1){
          // console.log(res);
          context.commit('initMessageTot',res.result.count)
        }else{
          this.$message.error(res.errorMsg)
        }
      })
    },
     //清空数量的接口
     clearMessageTotAsy(context){
      _clearNewTotal().then(res=>{
        if(res.resultCode==1){
          // console.log(res);
          context.commit('clearMessageTot',0)
        }else{
          this.$message.error(res.errorMsg)
        }
      })
    }
  },
  modules: {
  }
})
